import { useEffect, useRef, useState } from "react";
import classes from "./blogpage.module.scss";
import { Link, NavLink, useParams } from "react-router-dom";
import axios from "../../../requests/axios";
import routes from "../../../requests/routes";
import bp1 from "../../../assets/imgs/blogs/bp1.jpg";
import GlobeLoader from "../../../layouts/globeLoader/GlobeLoader";
import SmallBlogCard from "../../../generic components/small blog card/SmallBlogCard";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
import { ClockCircleOutlined } from "@ant-design/icons";
import { Carousel, Image } from "antd";
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft, FaArrowLeftLong } from "react-icons/fa6";
import { getViewerId } from "../../../utils/utils";

function BlogPage() {
  const { id } = useParams();
  const [date, setDate] = useState("");

  const [hasLoaded, setHasLoaded] = useState(false);
  const [blog, setBlog] = useState([]);
  const sentOnce = useRef(false);

  useEffect(() => {
    if (!blog?._id || sentOnce.current) return;

    // client-side de-dupe (avoid StrictMode double-call & quick refresh spam)
    const viewedKey = `viewed:${blog._id}`;
    if (sessionStorage.getItem(viewedKey)) {
      sentOnce.current = true;
      return;
    }
    sessionStorage.setItem(viewedKey, "1");

    sentOnce.current = true;

    const aid = getViewerId();
    axios
      .post(
        routes.blogRecordView(blog._id),
        {},
        {
          withCredentials: true, // send cookies if any
          headers: { "X-Viewer-Id": aid },
        }
      )
      .catch(() => {});

    if (localStorage.getItem(viewedKey)) return;
    localStorage.setItem(viewedKey, "1");
  }, [blog?._id]);

  useEffect(() => {
    setHasLoaded(false);
    window.scrollTo(0, 0);
    axios
      .get(routes.getBlogs + "/" + id)
      .then((res) => {
        setBlog(res.data.blog);
        let day = res.data.blog.created_at?.slice(0, 10);
        setDate(day);
        setHasLoaded(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  return (
    <>
      {!hasLoaded ? (
        <GlobeLoader />
      ) : (
        <>
          <div className={classes.back}>
            <Link to="/blogs">
              <FaArrowLeftLong
                style={{ color: "#151515" }}
                className={classes.backArrow}
              />
              <span>Back</span>
            </Link>
          </div>
          <div className={classes.bigContainer}>
            <div className={classes.container}>
              <div className={classes.ImageWrapper}>
                <Image
                  width={"100%"}
                  className={classes.Image}
                  src={blog.coverImage}
                  alt="blog"
                />
              </div>
              <h1 className={classes.title}>{blog.title}</h1>
              <div className={classes.textArea}>
                <p>{blog.summary}</p>
                <p
                  className={classes.text}
                  dangerouslySetInnerHTML={{ __html: `${blog.contentText}` }}
                ></p>
              </div>
              {blog.gallery.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "2rem",
                  }}
                >
                  <Image.PreviewGroup style={{ display: "flex" }}>
                    {blog.gallery.map((img, i) => (
                      <Image
                        width={200}
                        height={200}
                        src={img}
                        key={i}
                        style={{ objectFit: "cover" }}
                      />
                    ))}
                  </Image.PreviewGroup>
                </div>
              )}

              <h3 className={classes.details}>
                By: {blog.user?.fullName} |
                <span>
                  <ClockCircleOutlined />
                  {date}
                </span>
              </h3>
            </div>
            <BlogSidebar author={blog.user} />
          </div>
        </>
      )}
    </>
  );
}

export default BlogPage;
